import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import cloneDeep from 'lodash/cloneDeep';
import filter from 'lodash/filter';
import { isTrue } from '@/utils/boolean';
import { baseUrl } from '@/config';

const getters = {
  userInfo: (state) => state.user.userInfo,
  roles: (state) => state.user.roles,
  selectedMenu: (state) => state.common.selectedMenu,
  selectedNode: (state) => (isEmpty(state.common.selectedNode) ? {} : state.common.selectedNode),
  navigationPath: (state) => {
    const navigationPath = [
      {
        key: '_',
        type: '_',
        label: 'Home',
      },
    ];

    if (!isEmpty(state.common.selectedMenu)) {
      const menu = state.common.selectedMenu;
      navigationPath.push({
        key: menu.url,
        type: 'menu',
        label: menu.menuName,
        data: menu,
      });
    }

    if (!isEmpty(state.common.selectedNodePath)) {
      const nodePath = state.common.selectedNodePath;
      forEach(nodePath, (path) => {
        navigationPath.push({
          key: path.treeKey,
          type: 'node',
          label: path.label,
          data: path,
        });
      });
    }

    if (!isEmpty(state.common.activeTab)) {
      const activeTab = state.common.activeTab;
      navigationPath.push({
        // key: activeTab.name, // TODO: activeTab의 label까지 관리하도록 처리 필요.
        key: activeTab.name,
        type: 'tab',
        label: activeTab.label,
        // label: activeTab.label,
        data: activeTab,
      });
    }

    return navigationPath;
  },
  navigationPathLabel: (state, _getters) => {
    if (!isEmpty(_getters.navigationPath)) {
      let label = '';
      const length = _getters.navigationPath.length;
      for (let i = 0; i < length; i += 1) {
        label += _getters.navigationPath[i].label;
        if (length - 1 > i) {
          label += ' > ';
        }
      }
      return label;
    }
    return '';
  },
  isGroup: (state) => !isEmpty(state.common.selectedNode) && state.common.selectedNode.type === 'group',
  isObj: (state) => !isEmpty(state.common.selectedNode) && state.common.selectedNode.type === 'obj',
  /* 기간 필터 */
  /**
   * 분석 기간 파라미터 객체 (startDatetime / endDatetime)
   * @type {Object}
   */
  analysisDateParams: (state) => state.performance.analysisDateData.params,
  /**
   * 분석 시점 (일시)
   * @type {Date}
   */
  plotLineDatetime: (state) => state.performance.plotLineDatetime,
  /**
   * 기간 필터 컴포넌트 초기 값
   * @type {Object}
   */
  initialDatetimeRange: (state) => state.performance.initialDatetimeRange,
  isRelativeAnalysisDate: (state) => state.performance.analysisDateData.isRelative,
  selectedObjDefineIds: (state) => state.performance.selectedObjDefineIds,
  selectedObjDefineIdsForPhysical: (state) => state.performance.selectedObjDefineIdsForPhysical,
  eventlevelInfo: (state) => {
    const eventlevelInfo = cloneDeep(state.common.eventlevelInfo);
    if (eventlevelInfo.NM) {
      delete eventlevelInfo.NM;
    }
    return eventlevelInfo;
  },
  eventlevelInfoWithNM: (state) => state.common.eventlevelInfo,
  eventlevelList: (state) => filter(state.common.eventlevelList, (item) => item.eventlevelId !== 'NM'),
  eventlevelListWithNM: (state) => state.common.eventlevelList,
  configRules: (state) => state.config.configRules,
  rejectConfigEditing: (state) => state.config.rejectConfigEditing,
  saveConfigEditing: (state) => state.config.saveConfigEditing,
  selectedEvents: (state) => state.event.selectedEvents,
  urgencyData: (state) => state.event.urgencyData,
  impactData: (state) => state.event.impactData,
  activeTab: (state) => state.common.activeTab,
  activeManagetypes: (state) => state.common.activeManagetypes,
  activeManagetypesToShow: (state) => filter(state.common.activeManagetypes, (item) => isTrue(item.showFlag) && item.managetypeId !== 'EMS'),
  activeManagetypesToShowForRsc: (state) => filter(state.common.activeManagetypes, (item) => isTrue(item.showFlag) && item.managetypeId !== 'SVC'),
  activeManagetypeIds: (state) => {
    const activeManagetypeIds = [];
    forEach(state.common.activeManagetypes, (item) => {
      activeManagetypeIds.push(item.managetypeId);
    });
    return activeManagetypeIds;
  },
  rootMenuInfo: (state) => filter(state.common.menuInfo, (item) => isTrue(item.menuType === 'ROOT')),
  settingMenuInfo: (state) => filter(state.common.menuInfo, (item) => isTrue(item.menuType === 'SETTING' && item.parentMenuId === 'SETTING')),
  selectedVmsObjtypeIds: (state) => state.performance.selectedVmsObjtypeIds,
  autoMoveMenuInfo: (state) => state.setting.autoMoveMenuInfo,
  showSettingView: (state) => state.common.showSettingView,
  availableSensorList: (state) => state.common.availableSensorList,
  getCustomimage(state) {
    return state.common.customimage;
  },
  /**
   * 사용자 이미지 아이디로 이미지 경로를 반환한다.
   * @author KangBonghun(toto1323)
   * @param  {[type]} state [description]
   * @return {[type]}       [description]
   */
  getImageUrlById(state) {
    return (customimageId) => {
      let url = null;
      if (Object.prototype.hasOwnProperty.call(state.common.customimage, customimageId)) {
        url = `${baseUrl}/images/custom/${encodeURIComponent(state.common.customimage[customimageId].customimageSrc)}`;
      }
      return url;
    };
  },
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js